module.exports = __webpack_public_path__ + "static/img/user2.ec6ae432.png";